// React.
import React, {Fragment, useState} from 'react';

// Components.
import PreOrderItemSearch from '../preorders/PreOrderItemSearch';
import AddOrderShipping from '../orders/AddOrderShipping';
import AddPreOrderPayment from '../preorders/AddPreOrderPayment';
import AddOrderDetails from '../orders/AddOrderDetails';
import AddPreOrderCustomer from '../preorders/AddPreOrderCustomer';

// Material UI.
import Grid from '@material-ui/core/Grid';

// Model types.
import { ShippingType, AddressUserType } from '../../admin/models/ModelTypes';

const AddPreOrder = () => {

  const defaultAddressValues = {
    province: '',
    canton: '',
    district: '',
    fullAddress: '',
    phoneNumber: '',
    postalCode: ''
  }

  const [selectedShipping, setSelectedShipping] = useState<ShippingType>();
  const [selectedPayment, setSelectedPayment] = useState<string>('');
  const [isPartialPayment, setIsPartialPayment] = useState<boolean>(false);
  const [selectedAddressId, setSelectedAddressId] = useState<number>(0);
  const [selectedUserEmail, setSelectedUserEmail] = useState<string>('');
  const [customAddress, setCustomAddress] = useState<AddressUserType>(defaultAddressValues);
  const [validateAddress, setValidateAddress] = useState<boolean>(false);
  const [radioValue, setRadioValue] = useState<string>('custom');
  const [selectedVendor, setSelectedVendor] = useState<string>('');
  const [selectedCustomer, setSelectedCustomer] = useState<{id: string, email: string, firstName: string, lastName: string, phone?: string} | null>(null);


  return (
    <Fragment>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12}>
          <AddOrderShipping 
            selectedShipping={ selectedShipping }
            setSelectedShipping={ setSelectedShipping } 
            selectedAddressId={ selectedAddressId }
            setSelectedAddressId={ setSelectedAddressId }
            setCustomAddress={ setCustomAddress }
            customAddress={ customAddress }
            setValidateAddress={setValidateAddress}
            validateAddress={ validateAddress }
            setRadioValue={ setRadioValue }
            radioValue={ radioValue }
            quickOrder={ false }
            setSelectedUserEmail={ setSelectedUserEmail }
            selectedVendor={selectedVendor}
            setSelectedVendor={setSelectedVendor}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <AddPreOrderCustomer 
            selectedCustomer={selectedCustomer}
            onCustomerChange={setSelectedCustomer}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <PreOrderItemSearch />
        </Grid>
        <Grid item xs={12} sm={12}>
          <AddPreOrderPayment 
            setSelectedPayment={ setSelectedPayment }
            setIsPartialPayment={ setIsPartialPayment }
            isPartialPayment={ isPartialPayment }
            selectedPayment={ selectedPayment }
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <AddOrderDetails 
            selectedShipping={ selectedShipping }
            selectedPayment={ selectedPayment }
            selectedAddressId={ selectedAddressId }
            customAddress={ customAddress }
            setValidateAddress = { setValidateAddress }
            radioValue= { radioValue }
            quickOrder={ false }
            selectedUserEmail={ selectedCustomer?.email || selectedUserEmail }
            selectedVendor={selectedVendor}
            isPartialPayment={isPartialPayment}
            selectedCustomer={selectedCustomer}
          />
        </Grid>
      </Grid>
    </Fragment>
  )
}

export default AddPreOrder;